import { FC } from 'react';
import Image from 'next/image';
import Link from 'next/link';

import styles from './icons.module.scss';
import { assetsPath } from '../../../data/constants';
import { useIntl } from 'react-intl';

type IconData = {
  href: string;
  src: string;
  text: string;
  width: number;
  height: number;
};

const Icons: FC = () => {
  const { formatMessage } = useIntl();

  const iconData: IconData[] = [
    {
      href: 'https://mypharmacy.shoppersdrugmart.ca/en/refill',
      src: `${assetsPath}/site-icons/2020-site-icons/ico-prescriptions.svg`,
      text: 'refills',
      width: 17.341,
      height: 20.407,
    },
    {
      href: 'https://stores.shoppersdrugmart.ca',
      src: `${assetsPath}/site-icons/2020-site-icons/ico-stores.svg`,
      text: 'stores',
      width: 14,
      height: 16,
    },
    {
      href: 'https://www1.shoppersdrugmart.ca/en/flyer',
      src: `${assetsPath}/site-icons/2020-site-icons/ico-flyer.svg`,
      text: 'flyer',
      width: 16,
      height: 15.93,
    },
  ];

  return (
    <div className={styles.iconsContainer}>
      {iconData.map(({ href, src, text, width, height }) => (
        <Link href={href} target="_blank" rel="noopener noreferrer" className={styles.icon} key={href}>
          <Image
            src={src}
            width={width}
            height={height}
            alt={formatMessage({ id: text })}
            style={{ maxWidth: 'inherit' }}
          />
          <span>{formatMessage({ id: text })}</span>
        </Link>
      ))}
    </div>
  );
};

export default Icons;
